<div>
  <app-loading></app-loading>
  <app-navigation appDomChange *ngIf="showNav"></app-navigation>
  <app-print *ngIf="!showNav"></app-print>
  <terms *ngIf="termsService.showTerms"></terms>
</div>
